import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const apiBaseURL = process.env.VUE_APP_API_URL

const state = () => ({
  sections: [],
  courseComments: [],
  sectionComments: [],
  devInventory: [],
  currentSection: {},
  displayComp: 'SectionStatusBoard',
  targetTerm: 'Spring 2022',
})

const getters = {
  cp_sections: (state) => {
    return state.sections.sort((a, b) => {
      const ca = a.course.toLowerCase()
      const cb = b.course.toLowerCase()
      if (ca < cb) {
        return -1
      }
      if (ca > cb) {
        return 1
      }
      return 0
    })
  },
  cp_devInventory: (state) => {
    return state.devInventory
  },
  cp_courseComments: (state) => {
    return state.courseComments.filter((comment) => comment.status === 'Active')
  },
  cp_sectionComments: (state) => {
    return state.sectionComments.filter(
      (comment) => comment.status === 'Active',
    )
  },
  cp_displayComp: (state) => {
    return state.displayComp
  },
  cp_currentSection: (state) => {
    return state.currentSection
  },
}

const mutations = {
  cp_updateDevInventory(state, sites) {
    state.devInventory = sites.response.recordset
  },
  cp_updateSectionInfo(state, sections) {
    state.sections = sections.response.recordset
  },
  cp_updateCourseComments(state, comments) {
    state.courseComments = comments.response.recordset
  },
  cp_updateSectionComments(state, comments) {
    state.sectionComments = comments.response.recordset
  },
  cp_setCurrentSection(state, section) {
    state.currentSection = section
  },
  cp_setDisplayCompNursing(state, comp) {
    window.scrollTo(0, 0)
    state.displayCompNursing = comp
  },
  cp_setDisplayComp(state, comp) {
    window.scrollTo(0, 0)
    state.displayComp = comp
  },
}

const actions = {
  async cp_callAPI({ rootGetters }, config) {
    try {
      const result = await axios({
        url: `${apiBaseURL}${config.url}`,
        method: config.method || 'get',
        data: config.data,
        headers: {
          Authorization: `Bearer ${
            rootGetters.currentUser.token || config.token
          }`,
        },
      })
      return result.data
    } catch (err) {
      throw new Error(err)
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
